import { render } from "./InvoiceForm.vue?vue&type=template&id=5b563858&scoped=true"
import script from "./InvoiceForm.vue?vue&type=script&lang=js"
export * from "./InvoiceForm.vue?vue&type=script&lang=js"

import "./InvoiceForm.vue?vue&type=style&index=0&id=5b563858&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b563858"]])

export default __exports__